import { WorkflowActionsController } from './workflow-actions.controller';
import { WorkflowActionsComponentProps } from './workflow-actions.model';

const WorkflowActions = (props: WorkflowActionsComponentProps): JSX.Element => {
  return <WorkflowActionsController {...props} />;
};

export default WorkflowActions;
